/*
  Main File, 1st file to execute in project
*/

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import BootSetup from './BootSetup';

// Root container with render
createRoot(document.getElementById('root')).render(<BootSetup />);